import { render, staticRenderFns } from "./OperationTypeManagement.vue?vue&type=template&id=3473fbbd"
import script from "./OperationTypeManagement.vue?vue&type=script&lang=js"
export * from "./OperationTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./OperationTypeManagement.vue?vue&type=style&index=0&id=3473fbbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports